import { useContext } from "react"

//Helpers
import isParticipantActive from "../../../helpers/isParticipantActive"

//PrimeReact
import { Tooltip } from "primereact/tooltip"

// Context
import { UserContext } from "../../../context/userContext"
import { KIOSK_MEMBER } from "../../../config/globalsStatus"

export default function InactiveParticipantToolTip({ targetName, children }) {
  const userCtx = useContext(UserContext)
  const tooltipClass = `inactiveParticipant-tt-${targetName || "default"}`

  let tooltipText = null

  if (
    !isParticipantActive(userCtx.participant_membership_status) &&
    userCtx.participant_membership_status !== KIOSK_MEMBER
  ) {
    tooltipText = (
      <div>
        This participant is inactive <br />
        please start a new service episode
      </div>
    )
  }

  return (
    <span>
      <Tooltip target={`.${tooltipClass}`}>{tooltipText}</Tooltip>
      <div className={tooltipClass} data-pr-position="bottom">
        {children}
      </div>
    </span>
  )
}
